import React, { useEffect, useRef, useState } from "react";
import styles from "./styles.module.scss";
import ProgressBar from "../_basic/ProgressBar";
import { OnNavigationType } from "../_basic/SlideNavigation";
import { InterimAnimationSlideType } from "../../../types/interimAnimationSlide";

interface InterimAnimationSlideProps {
  data: InterimAnimationSlideType;
  inView: boolean;
  onNavigation: OnNavigationType;
}

const InterimAnimationSlide: React.FC<InterimAnimationSlideProps> = ({
  inView,
  data,
  onNavigation,
}) => {
  const [isAnimation, setIsAnimation] = useState(true);
  const [progress, setProgress] = useState(0);
  const intervalId = useRef<number | null>(null);
  const progressStep = 2;
  const interval = data.duration / (100 / progressStep);

  function getIconUrl(data: any) {
    const prefix = "https://slider-assets.cust.enpal.io/slider-images/";
    return data.icon && data.icon.startsWith("https://")
      ? data.icon
      : `${prefix}${data.icon}`;
  }

  useEffect(() => {
    var switched = false;
    if (inView) {
      setIsAnimation(true);
      setProgress(0);

      const durationTimer = setTimeout(() => {
        setIsAnimation(false);
      }, data.duration);

      intervalId.current = window.setInterval(() => {
        setProgress((prevProgress) => {
          if (prevProgress < 100) {
            return prevProgress + progressStep;
          } else {
            if (intervalId.current) {
              clearInterval(intervalId.current);
              setTimeout(() => {
                if (!switched) onNavigation(1);
                switched = true;
              }, 0);
            }
            return prevProgress;
          }
        });
      }, interval);
      return () => {
        if (durationTimer) clearTimeout(durationTimer);
        if (intervalId.current) clearInterval(intervalId.current);
      };
    }
  }, [inView]);

  return (
    <div className={styles.mainContainer}>
      <ProgressBar progress={progress} />
      <div className={styles.content}>
        {isAnimation ? (
          <img
            src={getIconUrl(data.loader)}
            alt="animation icon"
            className={styles.icon}
          />
        ) : (
          <img
            src={getIconUrl(data.success)}
            alt="success icon"
            className={styles.icon}
          />
        )}
        <div className={styles.titleContainer}>
          <div className={styles.title}>
            {isAnimation ? data.loader.title : data.success.title}
          </div>
          <div className={styles.description}>
            {isAnimation ? data.loader.subtitle : ""}
          </div>
        </div>
      </div>
    </div>
  );
};

export default InterimAnimationSlide;
